import { config } from "@/config/config";

export const passwordRegex =
  config.env !== "dev"
    ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.{8,16})(?!.*\s).*$/
    : /^.{8,}$/;
